import tool from '@mlib/js/tool/index.js'

/* 过滤器 */
const Filters = {}

// 用于 a 标签的 href 属性绑定链接时使用，
// 防止地址为空时点击a标签刷新页面。
// 检查 linkStr 是否为空，
Filters.checkHref = function (linkStr) {
    return linkStr || 'javascript:void(0);';
}

// 格式化date
// @param validDate 任何可以new Date()的有效日期
// @param fmt 形如 "yyyy-MM-dd hh:mm:ss", "MM月-dd日" 等字符串
Filters.formatDatetime = tool.date.formatDatetime

Filters.formatGoodDate = tool.date.formatGoodDate

// 根据传入时间获取星期几
Filters.getWeek = tool.date.getWeek

// 将秒转为时分秒
Filters.formatSeconds = function (value) {
    var second = parseInt(value), // 秒 
        minute = 0, // 分
        hour = 0; // 小时 

    if (second > 60) {
        minute = parseInt(second / 60);
        second = parseInt(second % 60);
        if (minute > 60) {
            hour = parseInt(minute / 60);
            minute = parseInt(minute % 60);
        }
    }

    var result = "" + parseInt(second) + "秒";
    if (minute > 0) {
        result = "" + parseInt(minute) + "分" + result;
    }
    if (hour > 0) {
        result = "" + parseInt(hour) + "小时" + result;
    }
    return result;
}

// 格式化数字
// @param number 必需，要格式化的数字
// @param decimals 可选，规定多少个小数位，默认两位。
// @param point 可选，规定用作小数点的字符串（默认为 . ）。
// @param thousands 可选，规定用作千位分隔符的字符串（默认为 , ），如果设置了该参数，那么所有其他参数都是必需的。
Filters.formatNumber = tool.formatNumber


//在formatNumber的基础上,百万级别用万为单位.
Filters.formatNumberUnit = tool.formatNumberUnit

// 格式化数字为最多2位小数，并且不大于传于的max值
Filters.format2Max = tool.format2Max

// 将html字符串中的文本提取出来;
// 用于微官网列表页中每一项的描述处;
Filters.htmlToText = function (html) {
    let div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText;
}

// 从字符串中截取指定长度片段;
// 用于微官网列表页中每一项的描述处;
Filters.sliceText = function (text, start = 0, end = 150) {
    return text.slice(start, end)
}

let _reg = /<br\/?>$/;
let _map = {
    r: /\<|\>|\&|\r|\n|\s|\'|\"/g,
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    ' ': '&nbsp;',
    '"': '&quot;',
    "'": '&#39;',
    '\n': '<br/>',
    '\r': ''
}
Filters.escape = function (text) {
    _content = Filters.encode(_map, text)
    return _content.replace(_reg, '<br/>');
}

Filters.encode = function (_map, _content) {
    _content = '' + _content
    if (!_map || !_content) {
        return _content || ''
    }
    return _content.replace(_map.r, function ($1) {
        var _result = _map[!_map.i ? $1.toLowerCase() : $1]
        return _result != null ? _result : $1
    });
};
// http://axure.xiaogj.com/liuyu/X3-3.7/#id=fjmbhw&p=%E5%BD%B1%E5%93%8D%E9%A1%B5%E9%9D%A2&g=1
// 开启了脱敏功能的机构脱敏
Filters.desensitization = function(_tel, start = 3, end = 7) {
    if (_tel === undefined) return '';
    if (!app.teacher.user.hidePhone) {
        return _tel;
    }
    return _tel.substr(0, start) + "*".repeat(Math.min(end, _tel.length)-start) + _tel.substr(end);
}
// 开启了脱敏功能的机构且未给拨号权限的脱敏
Filters.disableDialNumber = function(_tel, start = 3, end = 7) {
    if (_tel === undefined) return '';
    if (!app.teacher.user.disableDialNumber) {
        return _tel;
    }
    return _tel.substr(0, start) + "*".repeat(Math.min(end, _tel.length)-start) + _tel.substr(end);
}

export default Filters;